<template>
  <div :class="['loginInput', { ativo: foco }]">
    <i :class="icon"></i>
    <select
      class="loginSelect"
      v-model="valor"
      @change="selecao"
      @keyup="selecao"
      @focus="focar"
      @blur="desfocar"
      :ref="referencia"
      required
    >
      <option value=""  disabled>
        Selecione o usuario
      </option>
      <option
        v-for="obj in itens"
        :key="obj.Codigo"
        :value="obj.Codigo"
        :selected="obj.Codigo === '000001'"
      >
        {{ obj.Descricao }}
      </option>
    </select>
  </div>
</template>

<style scoped lang="scss">
.loginInput select {
  height: 40px;
  border-radius: 10px;
  border: 1px solid #aaa;
  text-align: left;
  padding: 10px;
  max-width: 300px;
  border-left: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.loginInput i {
  display: flex;
  align-items: center;
  height: 40px;
  border: 1px solid #aaa;
  border-radius: 10px;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  border-right: 0;
  padding-left: 5px;
}

.ativo {
  select {
    border: 1px solid #ac08f0 !important;
    border-left: 0 !important;
  }
  i {
    border: 1px solid #ac08f0 !important;
    border-right: 0 !important;
  }
}
</style>

<script>

export default {
  name: "login-select-usuario",
  data() {
    return {
      valor: "",
      foco: false,
    };
  },
  props: {
    icon: {
      type: String,
      description: "Input left icon",
    },
    type: {
      type: String,
      description: "Input type",
    },
    placeholder: {
      type: String,
      description: "Input placeholder",
    },
    itens: {
      type: Array,
      description: "Input Array",
    },
    referencia:{
      type: String,
      description: "Input ref"
    },
    valorAtual:{
      type: String,
      description: "Input valor selecionado"
    }
  },
  methods: {
    verificaUsuario() {
      this.valor = localStorage.getItem("usuarioSelecionado");
      return true;
    },
    selecao() {
      this.$emit("atualizarSelecao", { recebido: this.valor });
    },
    focar() {
      this.foco = true;
    },
    desfocar() {
        console.log()
        this.foco = false
    },
  },
  mounted() {
    this.verificaUsuario();
  }
};

</script>
